import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=57114bc3"
import script from "./GetInTouch.vue?vue&type=script&lang=ts"
export * from "./GetInTouch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports